// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cf4bccef","239":"9d420019","667":"03762ec1"}[chunkId] + ".chunk.js";
};